export default {"src":"/planos/_next/static/media/instagram-icon.c8353c6b.svg","height":14,"width":14,"blurWidth":0,"blurHeight":0};